/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { Currency } from '@app/settings/currencies/currency.model';

@Component({
  selector: 'app-currency-converter',
  templateUrl: './currency-converter.component.html',
  styleUrls: ['./currency-converter.component.scss'],
})
export class CurrencyConverterComponent implements OnInit {
  @Input() value: Number;
  @Input() fromCurrency: Currency;
  @Input() exchangeRate: number = null;

  constructor() {}

  ngOnInit(): void {
    if (this.exchangeRate) {
      this.fromCurrency.exchange_rate = this.exchangeRate;
    }
  }
}
